import http from "./../services/httpService";


export async function getGoogleServiceAccounts() {
    const resp = await http.get(`/google_service_accounts/`)
    return resp.data
}

export async function processOwnGoogleDriveFolders() {
    const resp = await http.post('/data_sources/process_own_google_drive_folders/')
    return resp.data
}

export async function processOwnAsanaTasks() {
    const resp = await http.post('/data_sources/poll_own_asana_tasks/')
    return resp.data
}
